import React           from 'react';
import submitButton    from '../../images/submitButton.png';
import { words }       from '../../utils/dictionary';
import { storeLogin }  from '../../utils';
import { makeStyles }  from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root: {
        position:   'fixed',
        height:     '15vh',
        minHeight:  '100px',
    },
    form_container: {
        width:           '100%',
        height:          '100%',
        display:         'flex',
        border:          '1px solid #226',
        flexFlow:        'column',
        alignItems:      'center',
        justifyContent:  'center',
        overflow:        'hidden',
        backgroundColor: '#FFF',
        transform:       'skew(-32deg)'
    },
    form: {
        flex:                1,
        width:               '90%',
        transform:           'skew(32deg)',
        backgroundColor:    '#FFF',
        display:             'flex',
        flexFlow:           'column',
        alignItems:         'center',
        justifyContent:     'space-evenly'
    },
    textFieldContainer: {
        width:          '100%',
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'space-around',
    },
    textField: {
        width:                   '45%',
        appearance:              'none',
        outline:                 'none',
        boxshadow:               'none',
        border:                  'none',
        borderBottom:            '1px solid #888',
        background:              'transparent',
        '&::-webkit-appearance': 'none',
        '&::-moz-appearance':    'none',
        '&::-ms-appearance':     'none',
        '&::-o-appearance':      'none', 
    },
    submitButton: {
        backgroundImage:    `url(${ submitButton })`,
        backgroundPosition: 'center',
        backgroundSize:     'contain',
        backgroundRepeat:   'no-repeat',
        backgroundColor:    'transparent',
        width:              '100%',
        height:             40,
        display:            'flex',
        flexFlow:           'column',
        alignItems:         'center',
        justifyContent:     'center',
        textAlign:          'center',
        color:              '#FFF',
        border:             'none',
        fontSize:           20,
        cursor:             'pointer',
    },
    newPwrd: {
        flex:           1,
        fontSize:       20,
        textAlign:      'center',
        textDecoration: 'none',
        color:          '#777'
    }
}))

type FormProps = {
    size:       number[];
    wideScreen: boolean;
    lang:       string;
}

const Form: React.FC<FormProps> = ({ lang, size, wideScreen }) => {

  const classes = useStyles();

  const rootstyle = React.useMemo(() => {
      return {
        width:     size[0] > 700 ? 430 : '80vw',
        top:       wideScreen ? '55vh' : '60vh',
        left:      wideScreen ? size[0] > 1000 ? '43vw' : '40vw' : '50%',
        transform: `translate(${ !wideScreen ? -50 : 0 }%, 50px)` //@@@

      }
  },[size, wideScreen])

  return (
    <div 
       className = { classes.root }
       style     = { rootstyle }
    >
        <div className = { classes.form_container }>
            <form 
            className        = { classes.form } 
            action           = "https://www.yisumatica.org.il/frontend/main/login" 
            method           = "post" 
            validate-form    = "true" 
            validation-error = "בדוק את השדות מסומנים"
            >
                <div className = { classes.textFieldContainer } dir = 'rtl'>
                    <input className = { classes.textField } type="text"     id="username" name="username" placeholder = { words[`userName`][lang] } required-field="true" /*validation = "[not-empty]"*/ autoComplete = "off"/>
                    <input className = { classes.textField } type="password" id="password" name="password" placeholder = { words[`password`][lang] } required-field="true" /*validation = "[not-empty]"*/ autoComplete = "off"/>
                </div>
                <button 
                    className = { classes.submitButton }
                    dir       = 'rtl' 
                    type      = "submit"
                    onClick   = { () => { storeLogin(lang) }}
                >
                   { words[`credentialsSignin`][lang] }
                </button>
                <div className = "moreButtons" dir = 'rtl'>
                    <a 
                       className = { classes.newPwrd }
                       href      = "https://www.yisumatica.org.il/reset_password" 
                    >
                         { words[`resetPassword`][lang] }
                    </a>
                </div>
            </form>
        </div>
    </div>
  );
}



export default Form;


